import React, { Component } from 'react';
import { PINTEREST_TAG_ID } from 'constants/vendor';

export const PINTEREST_SRC = 'https://s.pinimg.com/ct/core.js';

const PINTEREST_IMG = `https://ct.pinterest.com/v3/?tid=${PINTEREST_TAG_ID}&noscript=1`;

/**
 * implements the base code for the pinterest conversion tag.
 *
 * see https://developers.pinterest.com/docs/ad-tools/conversion-tag/
 *
 * PinterestConversionTag.pageView() should be called on every page view of the
 * site
 *
 */
class PinterestConversionTag extends Component {
  static Head() {
    if (!PINTEREST_TAG_ID) {
      return null;
    }
    return <script defer src={PINTEREST_SRC} />;
  }
  render() {
    if (!PINTEREST_TAG_ID) {
      return null;
    }
    return (
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<img src="${PINTEREST_IMG}" width="1" height="1" style="display: none;" />`
        }}
      />
    );
  }
}

/**
 * makes call to pinterest to track the current page.
 */
PinterestConversionTag.pageView = () => {
  if (!PINTEREST_TAG_ID) {
    return;
  }
  // slightly adapted from pinterest-provided JS
  if (!window.pintrk) {
    window.pintrk = (...args) => {
      window.pintrk.queue.push(Array.prototype.slice.call(args));
    };
    window.pintrk.queue = [];
    window.pintrk.version = '3.0';

    // this needs to only execute once per physical page load (not on every
    // client-side nav change), so it has been moved to the initial conditional
    // check.
    window.pintrk('load', PINTEREST_TAG_ID);
  }
  window.pintrk('page');
};

export default PinterestConversionTag;
